import { createFileRoute } from "@tanstack/react-router";
import {
  normalizeSearchScope,
  serializeSearchScope,
} from "@/features/search/searchScope";
import { SearchPage } from "@/pages/SearchPage";

export interface PublicSearchParams {
  q?: string;
  scope?: "op";
}

export const Route = createFileRoute("/search")({
  component: SearchPage,
  validateSearch: (search: Record<string, unknown>): PublicSearchParams => {
    const scope = serializeSearchScope(normalizeSearchScope(search.scope));
    return {
      q: typeof search.q === "string" ? search.q.slice(0, 100) : "",
      ...(scope ? { scope } : {}),
    };
  },
});
